export const SHORTLIST_STYLE_SCALE = {
  typography: {
    headline: {
      fontSize: 21,
      fontWeight: '600' as const,
    },
    titlePrimary: {
      fontSize: 17,
      fontWeight: '600' as const,
    },
    titleSecondary: {
      fontSize: 16,
      fontWeight: '500' as const,
    },
    body: {
      fontSize: 14,
      fontWeight: '400' as const,
    },
    bodyStrong: {
      fontSize: 14,
      fontWeight: '500' as const,
    },
    meta: {
      fontSize: 12,
      fontWeight: '400' as const,
    },
    badge: {
      fontSize: 12,
      fontWeight: '600' as const,
      letterSpacing: 0.4,
      textTransform: 'uppercase' as const,
    },
    sectionLabel: {
      fontSize: 12,
      fontWeight: '600' as const,
      letterSpacing: 0.8,
      textTransform: 'uppercase' as const,
    },
  },
  controls: {
    inputHeight: 52,
    searchHeight: 44,
    iconButtonSize: 34,
    rowMinHeight: 62,
    avatarSize: 48,
    cardRadius: 16,
  },
} as const;
